// extracted by mini-css-extract-plugin
module.exports = {"focusDiv":"_2PGgAK1eTCBm-xtngwvhl1"};